import { motion } from 'framer-motion'
import './XPBar.css'

export default function XPBar({ currentXP, xpForNextLevel }) {
  const currentLevel = Math.floor(currentXP / 100) + 1
  const xpInCurrentLevel = currentXP % 100
  const percentage = (xpInCurrentLevel / 100) * 100

  return (
    <div className="xp-bar-container">
      <div className="xp-bar-label">
        <span>{xpInCurrentLevel} / 100 XP</span>
        <span className="xp-remaining">{100 - xpInCurrentLevel} to Level {currentLevel + 1}</span>
      </div>
      <div className="xp-bar-track">
        <motion.div
          className="xp-bar-fill"
          initial={{ width: 0 }}
          animate={{ width: `${percentage}%` }}
          transition={{ duration: 0.3, ease: 'easeOut' }}
        />
      </div>
    </div>
  )
}
